const standorte = [
    'Augenklinik Dardenne',
    'Deutsches Endokrinologisches Versorgungszentrum DEVZ - MVZ',
    'Kinderwunschzentrum Langenhagen-Wolfsburg MVZ',
    'Labor Dr. Heidrch & Kollegen',
    'Labor Lübeck MVZ',
    'Labor Prof. Dr. G. Enders MVZ',
    'Laborarztpraxis Rhein-Main MVZ',
    'Labormedizinisches Versorgungszentrum Westmecklenburg',
    'Limbach Analytics',
    'Limbach Genetics',
    'Limbach Gruppe SE',
    'Limbach Nord',
    'MDI Limbach Berlin',
    'Medizinisches Labor Ostsachsen MVZ',
    'Medizinisches Labor Prof. Dr. Schenk, Dr. Ansorge & Kollegen',
    'Medizinisches Versorgungszentrum Dr. Stein + Kollegen',
    'MVZ Clotten Labor Dr. Haas, Dr. Raif & Kollegen',
    'MVZ GANZIMMUN',
    'MVZ Gemeinschaftslabor Cottbus',
    'MVZ Labor Dr. Fenner & Kollegen',
    'MVZ Labor Dr. Limbach & Kollegen',
    'MVZ Labor Dr. Reising-Ackermann und Kollegen',
    'MVZ Labor Dortmund Leopoldstraße',
    'MVZ Labor Essen Nienkampstraße',
    'MVZ Labor Limbach Erfurt/Suhl',
    'MVZ Labor Limbach Vorpommern-Rügen',
    'MVZ Labor Ludwigsburg',
    'MVZ Labor Münster Hafenweg',
    'MVZ Labor Passau',
    'MVZ Labor PD Dr. Volkmann und Kollegen',
    'MVZ Labor Prof. Blessing',
    'MVZ Labor Ravensburg/Ulm',
    'MVZ Labor Schweinfurt/Nürnberg',
    'MVZ Limbach Füssen',
    'MVZ Limbach Hamburg',
    'MVZ Limbach Magdeburg',
    'MVZ Limbach Wuppertal',
    'MVZ Medizinische Labore Dessau Kassel',
    'MVZ Medizinische Labore Limbach München Rosenheim',
    'MVZ Rheumatologie Hamburg',
    'Limbach Gruppe SE (VAULT)',
    'Limbach Gruppe SE (Aufsichtsrat)',
    'Medizinisches Labor Dresden MVZ',
    'Medics Labor AG',
];

standorte.sort((a, b) => a.localeCompare(b, 'de', {sensitivity: 'base'}));

export const STANDORTE = standorte;